import Reveal from "@/components/Reveal";

const solutions = [
  { name: "EXTERNAL STORAGE", desc: "Additional storage capacity when required.", testId: "solution-external" },
  { name: "OVERFLOW STORAGE", desc: "Additional capacity when internal storage is constrained.", testId: "solution-overflow" },
  { name: "BUFFER STORAGE", desc: "Practical inventory positioning for operational requirements.", testId: "solution-buffer" },
  { name: "TEMPORARY STORAGE", desc: "Flexible storage for short-term requirements.", testId: "solution-temporary" },
  { name: "EXPORT CONSOLIDATION", desc: "Storage before dispatch where applicable.", testId: "solution-export" },
];

const Solutions = () => (
  <section id="solutions" data-testid="solutions-section" className="scroll-mt-20 bg-ujn-sand text-ujn-charcoal">
    <div className="mx-auto max-w-7xl px-5 py-20 sm:py-28 lg:px-8">
      <Reveal className="max-w-2xl">
        <p className="font-mono text-[11px] tracking-[0.28em] text-ujn-medium">STORAGE SOLUTIONS</p>
        <h2 className="mt-5 font-heading text-2xl font-bold tracking-tight text-ujn-deep sm:text-3xl lg:text-4xl">
          FLEXIBLE STORAGE SOLUTIONS
        </h2>
      </Reveal>

      <Reveal delay={0.1} className="mt-14 divide-y divide-ujn-medium/15 border-y border-ujn-medium/15">
        {solutions.map((s, i) => (
          <div
            key={s.testId}
            data-testid={s.testId}
            className="grid gap-2 py-7 sm:grid-cols-[80px_1fr_2fr] sm:items-baseline sm:gap-8"
          >
            <span className="font-mono text-xs tracking-[0.2em] text-ujn-medium">0{i + 1}</span>
            <h3 className="font-heading text-lg font-semibold tracking-tight text-ujn-deep sm:text-xl">
              {s.name}
            </h3>
            <p className="text-sm leading-relaxed text-ujn-charcoal/75 sm:text-base">{s.desc}</p>
          </div>
        ))}
      </Reveal>
    </div>
  </section>
);

export default Solutions;
